export const acronymTooltips = {
  CHI: "ACM CHI Conference on Human Factors in Computing Systems",
  DIS: "ACM Conference on Designing Interactive Systems",
  PACIS: "Pacific Asia Conference on Information Systems",
  HCII: "International Conference on Human-Computer Interaction",
  PWiP: "Provocations and Work-in-Progress",
};